module.exports = __webpack_public_path__ + "static/media/detail_0053_f.66539d53.jpg";